<template>

  <div class="mt-4">
    <h5 class="section-title"><i class="bi bi-filetype-xls"></i>Сравнение размещённого текста с ТЗ</h5>

    <table v-if="link.rule" class="pf-ckeditor-table">
      <tbody>
      <tr v-if="link.result.removed_colored">
        <b>Были удалены цветные блоки теста</b>
      </tr>
      <tr>
        <td>

          <!-- Верхняя таблица с параметрами (2 режима) -->
          <table class="pf-table">
            <thead>
            <tr>
              <th>Параметр</th>
              <th>Факт 1 (ТОЛЬКО ТЕКСТ) БУРЖ</th>
              <th>План 1</th>
              <th>Факт 2 (ТЕКСТ + заголовки + технические разделы) РФ</th>
              <th>План 2</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td><b>Символов на текст:</b></td>
              <td>
                  <span :style="{ color: link.result.base[0].length < link.rule.base[0].length ? '#ff0000' : '' }">
                    {{ link.result.base[0].length }}
                  </span>
              </td>
              <td>{{ link.rule.base[0].length }}</td>
              <td>
                  <span :style="{ color: link.result.base[1].length < link.rule.base[0].length ? '#ff0000' : '' }">
                    {{ link.result.base[1].length }}
                  </span>
              </td>
              <td>{{ link.rule.base[0].length }}</td>
            </tr>
            <tr>
              <td><b>Плотность ключей:</b></td>
              <td>
                  <span
                      :style="{ color: link.result.base[0].density > link.rule.base[0].density ? '#ff0000' : '#0A970A' }">
                    {{ link.result.base[0].density }}
                  </span>
              </td>
              <td>{{ link.rule.base[0].density }}</td>
              <td>
                  <span
                      :style="{ color: link.result.base[1].density > link.rule.base[0].density ? '#ff0000' : '#0A970A' }">
                    {{ link.result.base[1].density }}
                  </span>
              </td>
              <td>{{ link.rule.base[0].density }}</td>
            </tr>
            <tr>
              <td><b>Должно быть ключей:</b></td>
              <td>
                  <span
                      :style="{ color: link.result.base[0].key_count < link.rule.base[0].key_count ? '#ff0000' : '' }">
                    {{ link.result.base[0].key_count }}
                  </span>
              </td>
              <td>{{ link.rule.base[0].key_count }}</td>
              <td>
                  <span
                      :style="{ color: link.result.base[1].key_count < link.rule.base[0].key_count ? '#ff0000' : '' }">
                    {{ link.result.base[1].key_count }}
                  </span>
              </td>
              <td>{{ link.rule.base[0].key_count }}</td>
            </tr>
            <tr>
              <td><b>Изображений:</b></td>
              <td>
                  <span
                      :style="{ color: link.result.base[0].image_count < link.rule.base[0].image_count ? '#ff0000' : '' }">
                    {{ link.result.base[0].image_count }}
                  </span>
              </td>
              <td>{{ link.rule.base[0].image_count }}</td>
              <td>
                  <span
                      :style="{ color: link.result.base[1].image_count < link.rule.base[0].image_count ? '#ff0000' : '' }">
                    {{ link.result.base[1].image_count }}
                  </span>
              </td>
              <td>{{ link.rule.base[0].image_count }}</td>
            </tr>
            <tr>
              <td><b>Таблиц:</b></td>
              <td>
                  <span
                      :style="{ color: link.result.base[0].table_count < link.rule.base[0].table_count ? '#ff0000' : '' }">
                    {{ link.result.base[0].table_count }}
                  </span>
              </td>
              <td>{{ link.rule.base[0].table_count }}</td>
              <td>
                  <span
                      :style="{ color: link.result.base[1].table_count < link.rule.base[0].table_count ? '#ff0000' : '' }">
                    {{ link.result.base[1].table_count }}
                  </span>
              </td>
              <td>{{ link.rule.base[0].table_count }}</td>
            </tr>
            <tr>
              <td><b>Исходящих ссылок:</b></td>
              <td>
                  <span
                      :style="{ color: link.result.base[0].links_count < link.rule.base[0].links_count ? '#ff0000' : '' }">
                    {{ link.result.base[0].links_count }}
                  </span>
              </td>
              <td>{{ link.rule.base[0].links_count }}</td>
              <td>
                  <span
                      :style="{ color: link.result.base[1].links_count < link.rule.base[0].links_count ? '#ff0000' : '' }">
                    {{ link.result.base[1].links_count }}
                  </span>
              </td>
              <td>{{ link.rule.base[0].links_count }}</td>
            </tr>
            <tr>
              <td><b>Исходящих ссылок:</b></td>
              <td colspan="3" v-html="link.result.base[0].links.replace(/\n/g, '<br>')"></td>
              <td>{{ link.rule.base[0].links_count }}</td>
            </tr>
            <tr>
              <td><b>Дата проверки:</b></td>
              <td colspan="4">{{ currentDate }}</td>
            </tr>
            </tbody>
          </table>

          <br>
          <hr>
          <p><b>Таблица 1 (кол-во и типы ключевых запросов)</b></p>
          <br>
          <table class="pf-table">
            <thead>
            <tr>
              <th>Запрос (факт/план)</th>
              <th>Title</th>
              <th>Description</th>
              <th>H1</th>
              <th v-for="(_, idx) in link.rule.headers[0].h2" :key="'h2-head-' + idx">H2</th>
              <th v-for="(_, idx) in link.rule.headers[0].lead" :key="'lead-head-' + idx">Лид</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(keyRule, ruleIdx) in link.rule.headers" :key="'header-row-' + ruleIdx">
              <template v-if="link.result.headers[ruleIdx]">
                <td>{{ link.result.headers[ruleIdx].key }}</td>
                <td style="text-align: center">
                  <b :style="{ color: getColor(link.result.headers[ruleIdx].title, keyRule.title) }">
                    {{ link.result.headers[ruleIdx].title }}
                  </b> | {{ keyRule.title }}
                </td>
                <td style="text-align: center">
                  <b :style="{ color: getColor(link.result.headers[ruleIdx].description, keyRule.description) }">
                    {{ link.result.headers[ruleIdx].description }}
                  </b> | {{ keyRule.description }}
                </td>
                <td style="text-align: center">
                  <b :style="{ color: getColor(link.result.headers[ruleIdx].h1, keyRule.h1) }">
                    {{ link.result.headers[ruleIdx].h1 }}
                  </b> | {{ keyRule.h1 }}
                </td>
                <td
                    v-for="(ruleH2, h2Idx) in keyRule.h2"
                    :key="'h2-' + ruleIdx + '-' + h2Idx"
                    style="text-align: center"
                >
                  <b :style="{ color: getColor(link.result.headers[ruleIdx].h2?.[h2Idx], ruleH2) }">
                    {{ link.result.headers[ruleIdx].h2?.[h2Idx] >= 0 ? link.result.headers[ruleIdx].h2[h2Idx] : '—' }}
                  </b> | {{ ruleH2 }}
                </td>
                <td
                    v-for="(ruleLead, leadIdx) in keyRule.lead"
                    :key="'lead-' + ruleIdx + '-' + leadIdx"
                    style="text-align: center"
                >
                  <b :style="{ color: getColor(link.result.headers[ruleIdx].lead?.[leadIdx], ruleLead) }">
                    {{
                      link.result.headers[ruleIdx].lead?.[leadIdx] >= 0 ? link.result.headers[ruleIdx].lead[leadIdx] : '—'
                    }}
                  </b> | {{ ruleLead }}
                </td>
              </template>
            </tr>
            </tbody>
          </table>

          <br>
          <hr>
          <p><b>Таблица 1.1 (Проверка H2 разделов)</b></p>
          <br>
          <table class="pf-table">
            <thead>
            <tr>
              <th>Параметр</th>
              <template v-for="(_, idx) in link.result.paragraphs.length" :key="'h2-head-' + idx">
                <th style="border: 2px solid #383b42; padding: 3px 5px;">H2 {{ idx + 1 }} факт</th>
                <th style="border: 2px solid #383b42; padding: 3px 5px;">План</th>
              </template>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td><b>Объем, слов</b></td>
              <template v-for="(length, idx) in link.result.paragraphs.length" :key="'len-' + idx">
                <td style="text-align: center">
                    <span :style="{ color: getColor(length, link.rule.paragraphs.length?.[idx]) }">
                      {{ length }}
                    </span>
                </td>
                <td style="text-align: center">{{ link.rule.paragraphs.length?.[idx] ?? 0 }}</td>
              </template>
            </tr>
            <tr>
              <td><b>Наличие картинки</b></td>
              <template v-for="(image, idx) in link.result.paragraphs.image" :key="'img-' + idx">
                <td style="text-align: center">
                    <span :style="{ color: getColor(image, link.rule.paragraphs.image?.[idx]) }">
                      {{ image }}
                    </span>
                </td>
                <td style="text-align: center">{{ link.rule.paragraphs.image?.[idx] ?? 0 }}</td>
              </template>
            </tr>
            <tr>
              <td><b>Наличие маркированного списка</b></td>
              <template v-for="(rowsList, idx) in link.result.paragraphs.rows_list" :key="'rows-' + idx">
                <td style="text-align: center">
                    <span :style="{ color: getColor(rowsList, link.rule.paragraphs.rows_list?.[idx]) }">
                      {{ rowsList }}
                    </span>
                </td>
                <td style="text-align: center">{{ link.rule.paragraphs.rows_list?.[idx] ?? 0 }}</td>
              </template>
            </tr>
            <tr>
              <td><b>Наличие исходящей ссылки</b></td>
              <template v-for="(links, idx) in link.result.paragraphs.links" :key="'links-' + idx">
                <td style="text-align: center">
                    <span :style="{ color: getColor(links, link.rule.paragraphs.links?.[idx]) }">
                      {{ links }}
                    </span>
                </td>
                <td style="text-align: center">{{ link.rule.paragraphs.links?.[idx] ?? 0 }}</td>
              </template>
            </tr>
            </tbody>
          </table>

          <br>
          <hr>
          <p><b>Таблица 2 (кол-во и типы ключевых запросов в тексте)</b></p>
          <br>
          <table class="pf-table">
            <thead>
            <tr>
              <th>Запрос (факт/план)</th>
              <th>Всего</th>
              <th>Прямое</th>
              <th>Свободное</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(key, idx) in link.result.keywords" :key="'kw-' + idx">
              <template v-if="link.rule.keywords[idx]">
                <td>
                  <b v-if="idx === link.result.keywords.length - 1">{{ key.key }}</b>
                  <span v-else>{{ key.key }}</span>
                </td>
                <td style="text-align: center">
                  <b :style="{ color: getColor(key.total, link.rule.keywords[idx].total) }">
                    {{ key.total }}
                  </b> | {{ link.rule.keywords[idx].total }}
                </td>
                <td style="text-align: center">
                  <b :style="{ color: getColor(key.direct, link.rule.keywords[idx].direct) }">
                    {{ key.direct }}
                  </b> | {{ link.rule.keywords[idx].direct }}
                </td>
                <td style="text-align: center">
                  <b :style="{ color: getColor(key.free, link.rule.keywords[idx].free) }">
                    {{ key.free }}
                  </b> | {{ link.rule.keywords[idx].free }}
                </td>
              </template>
            </tr>
            </tbody>
          </table>

          <br>
          <hr>
          <p><b>Таблица 3 Дополнительные слова</b></p>
          <br>
          <table class="pf-table">
            <thead>
            <tr>
              <th>Запрос (факт/план)</th>
              <th>Всего</th>
              <th>Разделы</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(key, idx) in link.result.semantic" :key="'sem-' + idx">
              <template v-if="link.rule.semantic[idx]">
                <td>
                  <b v-if="idx === link.result.semantic.length - 1">{{ key.key }}</b>
                  <span v-else>{{ key.key }}</span>
                </td>
                <td style="text-align: center">
                  <b :style="{ color: getColor(key.total, link.rule.semantic[idx].total) }">
                    {{ key.total }}
                  </b> | {{ link.rule.semantic[idx].total }}
                </td>
                <td style="text-align: center">
                  <template v-for="(sec, secIdx) in key.section" :key="'sec-fact-' + secIdx">
                      <span
                          :style="{ color: !link.rule.semantic[idx].section.includes(sec) && link.rule.semantic[idx].section.length ? '#ff0000' : '' }">
                        {{ sec }}
                      </span>
                    <template v-if="secIdx < key.section.length - 1">,</template>
                  </template>
                  <template v-if="link.rule.semantic[idx].section.length"> |</template>
                  <template v-for="(sec, secIdx) in link.rule.semantic[idx].section" :key="'sec-plan-' + secIdx">
                      <span :style="{ color: !key.section.includes(sec) ? '#ff0000' : '' }">
                        {{ sec }}
                      </span>
                    <template v-if="secIdx < link.rule.semantic[idx].section.length - 1">,</template>
                  </template>
                </td>
              </template>
            </tr>
            </tbody>
          </table>

        </td>
      </tr>
      </tbody>
    </table>
    <div class="empty-state" v-else>
      <i class="bi bi-inbox"></i>
      <p>Не найдена ссылка на ТЗ</p>
    </div>
  </div>


</template>

<script>


export default {
  name: 'TargetTables',
  props: {
    link: {
      type: Object,
      required: true
    }
  },
  computed: {
    currentDate() {
      const now = new Date();
      const day = String(now.getDate()).padStart(2, '0');
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const year = now.getFullYear();
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      return `${day}.${month}.${year} ${hours}:${minutes}`;
    }
  },
  data() {
    return {}
  },
  mounted: function () {


  },
  methods: {
    getColor(fact, plan) {
      if (fact === undefined || fact === null) return '';
      if (plan === undefined || plan === null) return '';
      if (fact < plan) return '#ff0000';
      if (plan || fact) return '#0A970A';
      return '';
    },
  }
}

</script>

<style scoped lang="scss">
.section-title {
  background: rgba(60, 60, 60, 1);
  padding: 10px;
  border-radius: 12px;
  color: #fff;
  font-size: 1.05rem;
      display: flex;
    gap: 5px;
}

.pf-ckeditor-table {
  width: 100%;
  border-collapse: collapse;
}

.pf-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 10px;
}

.pf-table th,
.pf-table td {
  border: 1px solid #ccc;
  padding: 5px 8px;
  vertical-align: top;
}

.pf-table th {
  background-color: #f5f5f5;
  font-weight: bold;
}

.pf-table td {
  font-size: 14px;
}

hr {
  border: 0;
  border-top: 1px solid #ddd;
  margin: 15px 0;
}

b {
  font-weight: 600;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px 20px;
  color: #adb5bd;
  text-align: center;
  width: 250px;

  i {
    font-size: 3rem;
    margin-bottom: 16px;
    opacity: 0.5;
  }

  p {
    margin: 0;
    font-size: 0.95rem;
  }
}


</style>
